import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class SearchService {
	private _reportSearchTerm = new BehaviorSubject<string>("");
	private _bauteilSearchTerm = new BehaviorSubject<string>("");
	searchTerm: Observable<string>;
	bauteilSearchTerm: Observable<string>;
	constructor() {
		this.searchTerm = this._reportSearchTerm.asObservable();
		this.bauteilSearchTerm = this._bauteilSearchTerm.asObservable();
	}
	changeSearchTerm(searchTerm: string) {
		this._reportSearchTerm.next(searchTerm);
	}
	changeBauteilSearchTerm(searchTerm: string) {
		this._bauteilSearchTerm.next(searchTerm);
	}
}
